export function ensureString(val: unknown): string | null {
  if (typeof val === 'string') {
    return val;
  } else {
    return null;
  }
}
